import React, {useContext} from 'react';
import * as R from 'ramda';
import AmoebaLink from '@/components/AmoebaLink';
import AmoebaForm from '@/components/AmoebaForm';
import {Navbar, Nav, NavItem} from 'reactstrap';
import ServiceNav from '@/views/Layout/internal/InternalNavBar/ServiceNav';
import BatchNav from '@/views/Layout/internal/InternalNavBar/BatchNav';
import CommissionNav from '@/views/Layout/internal/InternalNavBar/CommissionNav';
import SubsystemNav from '@/views/Layout/internal/InternalNavBar/SubsystemNav';
import Icon from '@/views/shared/Icon';
import styles from '@/views/Layout/internal/InternalNavBar/index.module.css';
import {userCtx} from '@/auth';
import {SystemConfigCtx} from '@/contexts';
import {MainMenuFor} from '@/views/Layout/internal/InternalNavBar/detectMenu';

const InternalNav = () => {
  const {currentStaff} = useContext(userCtx);
  const {siteName} = useContext(SystemConfigCtx);

  return (
    <>
      <div className={styles.main_title}>
        <AmoebaLink href='/'>Amoeba - {siteName}</AmoebaLink>
        <div style={{float: 'right'}}>
          <AmoebaForm>
            <input
              name='search'
              placeholder='Search'
              type='text'
              className={styles.round_input}
            />
          </AmoebaForm>
        </div>
      </div>
      <Navbar expand='md' className={styles.main_bar}>
        <Nav navbar className='mr navbar-dark'>
          <ServiceNav />
          <BatchNav />
          <CommissionNav />
          <SubsystemNav />
          <MainMenuFor name='report' label='Report' />
          <MainMenuFor name='user' label='User' />
          <MainMenuFor name='newsLetter' label='Newsletter' />
          <MainMenuFor name='settings' label='Settings' />
          <MainMenuFor name='chart' label='Chart' />
          <MainMenuFor name='valuation' label='Valuation' />
          <MainMenuFor name='datafeed' label='Data Feed' />
          <MainMenuFor name='bvFactor' label='BV Factor' />
          <MainMenuFor name='sync' label='Sync' />
        </Nav>
        <Nav navbar className='mr navbar-dark ml-auto'>
          <NavItem className={`nav-link ${styles.nav_link}`}>
            <AmoebaLink href='/user_session/edit'>
              <Icon icon='user' /> {R.propOr('', 'name', currentStaff)}
            </AmoebaLink>
          </NavItem>
          <NavItem className={`nav-link ${styles.nav_link}`}>
            <AmoebaLink href='/logout'>
              <Icon icon='sign-out-alt' /> Logout
            </AmoebaLink>
          </NavItem>
        </Nav>
      </Navbar>
    </>
  );
};

export default InternalNav;
